export default {
  // 通用
  defaultDishName: '預設餐盤',
  login: '登入',
  logout: '登出',
  cancel: '取消',
  confirm: '確定',
  delete: '刪除',
  edit: '編輯',
  save: '儲存',
  update: '更新',
  create: '創建',
  add: '添加',
  loading: '載入中...',
  
  // 主頁面 - 頂部導航
  title: 'AI Prompts',
  adminEntry: '管理員入口',
  toggleSidebar: '切換側邊欄',
  
  // 主頁面 - 左側面板
  dishManagement: '餐盤管理',
  officialDish: '官方餐盤',
  shareCodeSearch: '簡碼搜尋餐盤',
  myDishes: '我的餐盤',
  addDish: '新增餐盤',
  createFirstDish: '建立第一個餐盤',
  noDishesYet: '尚未建立任何餐盤',
  pleaseLoginFirst: '請先登入查看您的餐盤',
  
  // 主頁面 - 中間內容區域
  loadingPromptData: '正在載入 AI Prompt 資料...',
  officialPromptDish: 'HT AI 官方指令餐盤',
  shareCodeSearchPlaceholder: '請輸入分享代碼',
  searchDish: '搜尋餐盤',
  showAll: '全部顯示',
  noPromptData: '尚無 AI Prompt 資料',
  pleaseUploadFile: '請先上傳 HT_AIprompt.xlsx 檔案',
  goToAdminUpload: '前往管理員上傳',
  
  // 自訂餐盤視圖
  promptList: '指令列表',
  addPrompt: '添加指令',
  noDishSelected: '請選擇一個餐盤',
  selectDishHint: '點擊左側的餐盤來查看其內容',
  emptyDishTitle: '此餐盤尚未添加任何指令',
  emptyDishHint: '開始添加您的專屬 AI 指令吧！',
  addFirstPrompt: '添加第一個指令',
  loadingPrompts: '載入指令中...',
  noPromptsFound: '沒有找到指令',
  
  // 預覽面板
  promptDetails: '指令詳情',
  editPrompt: '編輯指令',
  sendToHT: '引入',
  
  // 表單欄位標籤
  promptCategory: '指令分類',
  promptPurpose: '指令用途',
  howToUse: '使用方式',
  usage: '使用方式',
  sourceData: '來源資料',
  conditionalPrompt: '條件式指令',
  promptContent: '指令內容',
  expectedOutput: '預期輸出',
  followUpActions: '後續行動',
  personalNotes: '個人備註',
  creator: '創建者',
  unknown: '未知',
  
  // 分類選項
  categories: {
    score: '評分',
    general: '常用',
    quiz: '出題',
    custom: '其他自訂',
    pickup: '挑選',
    mindMap: '心智圖'
  },
  
  // 新增餐盤對話框
  addDishModal: {
    title: '新增 AI 指令餐盤',
    nameLabel: '餐盤名稱',
    nameRequired: '餐盤名稱 *',
    namePlaceholder: '請輸入餐盤名稱',
    descriptionLabel: '餐盤描述',
    descriptionPlaceholder: '請輸入餐盤描述（選填）',
    isPublicLabel: '公開餐盤（其他用戶可以查看）',
    creating: '創建中...',
    confirmCreate: '確認創建'
  },
  
  // 編輯餐盤對話框
  editDishModal: {
    title: '編輯餐盤',
    updating: '更新中...',
    confirmUpdate: '確認更新',
    defaultNameNotEditable: '預設餐盤名稱無法修改',
    dishSharing: '餐盤分享',
    publishing: '發布中...',
    publishShare: '發布共用',
    closeShare: '關閉共用'
  },
  
  // 添加指令對話框
  addPromptModal: {
    title: '添加 AI 指令',
    categoryLabel: '指令分類 *',
    categoryPlaceholder: '請選擇分類',
    purposeLabel: '指令用途 *',
    purposePlaceholder: '例如：生成國中數學幾何單元課程大綱',
    usageLabel: '使用方式',
    usagePlaceholder: '例如：輸入單元名稱和年級，自動生成完整教學大綱',
    sourceDataLabel: '來源資料',
    sourceDataPlaceholder: '例如：教育部課綱、教學經驗',
    conditionalPromptLabel: '條件式指令 *',
    conditionalPromptPlaceholder: '例如：請根據[單元名稱]和[年級]，生成包含學習目標、教學活動、評量方式的課程大綱',
    expectedOutputLabel: '預期輸出',
    expectedOutputPlaceholder: '例如：結構化的課程大綱，包含教學目標、重點概念、活動設計、評量標準',
    followUpActionsLabel: '後續行動',
    followUpActionsPlaceholder: '例如：檢視大綱內容，調整教學活動順序，準備教材',
    personalNotesLabel: '個人備註',
    personalNotesPlaceholder: '例如：適合幾何單元，可搭配實體教具演示',
    adding: '添加中...',
    confirmAdd: '確認添加'
  },
  
  // 編輯指令對話框
  editPromptModal: {
    title: '編輯 AI 指令',
    categoryLabel: '指令分類 *',
    categoryPlaceholder: '請選擇分類',
    purposeLabel: '指令用途 *',
    purposePlaceholder: '例如：生成國中數學幾何單元課程大綱',
    usageLabel: '使用方式',
    usagePlaceholder: '例如：輸入單元名稱和年級，自動生成完整教學大綱',
    sourceDataLabel: '來源資料',
    sourceDataPlaceholder: '例如：教育部課綱、教學經驗',
    conditionalPromptLabel: '條件式指令 *',
    conditionalPromptPlaceholder: '例如：請根據[單元名稱]和[年級]，生成包含學習目標、教學活動、評量方式的課程大綱',
    expectedOutputLabel: '預期輸出',
    expectedOutputPlaceholder: '例如：結構化的課程大綱，包含教學目標、重點概念、活動設計、評量標準',
    followUpActionsLabel: '後續行動',
    followUpActionsPlaceholder: '例如：檢視大綱內容，調整教學活動順序，準備教材',
    personalNotesLabel: '個人備註',
    personalNotesPlaceholder: '例如：適合幾何單元，可搭配實體教具演示',
    updating: '更新中...',
    confirmUpdate: '確認更新'
  },
  
  // 刪除確認對話框
  deleteConfirmModal: {
    dishTitle: '確認刪除餐盤',
    promptTitle: '確認刪除指令',
    deleting: '刪除中...',
    confirmDelete: '確定刪除'
  },
  
  // 管理員登入頁面
  adminLogin: {
    title: '管理員登入',
    backButton: '← 返回',
    adminVerification: '管理員驗證',
    subtitle: '請輸入管理員憑證以繼續',
    userIdLabel: '用戶 ID',
    passphraseLabel: '管理員密鑰',
    passphrasePlaceholder: '請輸入管理員通關密鑰',
    verifying: '驗證中...',
    verifyAndLogin: '驗證並登入',
    enterPassphrase: '請輸入管理員密鑰',
    wrongPassphrase: '管理員密鑰錯誤，請重新輸入',
    verificationFailed: '驗證失敗，請稍後重試',
    noLoginInfo: '未找到用戶登入資訊，請重新登入',
    noAdminPermission: '您沒有管理員權限',
    invalidLoginInfo: '登入資訊無效，請重新登入'
  },
  
  // 管理員上傳頁面
  adminUpload: {
    title: '管理員檔案上傳',
    backButton: '← 返回',
    adminBadge: '管理員',
    uploadTitle: 'AI Prompt 檔案上傳',
    uploadSubtitle: '支援 Excel 多語系檔案，拖曳或點擊上傳',
    currentFileLabel: '📄 當前檔案：',
    downloadCurrentFile: '（點擊下載當前版本）',
    uploadWarning: '⚠️ 上傳新檔案將會覆蓋現有的 HT_AIprompt.xlsx 檔案',
    dropZoneText: '拖曳檔案到此處或',
    selectFile: '選擇檔案',
    supportedFormat: '支援格式：.xlsx',
    startUpload: '開始上傳',
    uploading: '正在上傳...',
    onlyXlsxSupported: '僅支援 Excel (.xlsx) 格式檔案',
    fileTooLarge: '檔案大小不能超過 10MB',
    uploadSuccess: 'AI Prompt Excel檔案上傳完成',
    uploadFailed: '檔案上傳失敗，請重試',
    noValidLanguageData: 'Excel檔案中沒有找到有效的語言資料',
    cannotGetUploadPermission: '無法獲取上傳權限'
  },
  
  // 成功/錯誤訊息
  messages: {
    loginSuccess: '登入成功！',
    loginFailed: '登入失敗',
    logoutSuccess: '登出成功',
    logoutFailed: '登出失敗',
    adminVerificationSuccess: '管理員驗證成功！',
    dishCreated: '餐盤創建成功！',
    dishUpdated: '餐盤更新成功！',
    dishDeleted: '餐盤已刪除',
    promptAdded: '指令添加成功！',
    promptUpdated: '指令更新成功！',
    promptDeleted: '指令已刪除',
    copied: '內容已複製到剪貼簿',
    copyFailed: '複製失敗',
    pleaseSelectDishFirst: '請先選擇一個餐盤',
    pleaseLoginToAddDish: '請先登入後再新增餐盤',
    pleaseLoginToAddPrompt: '請先登入後再添加指令',
    pleaseLogin: '請先登入',
    pleaseEnterDishName: '請輸入餐盤名稱',
    pleaseFillRequiredFields: '請填寫必填欄位',
    noDataChanges: '資料未有變更，無需儲存',
    dishNotPublic: '餐盤擁有者已設為不公開',
    missingRequiredInfo: '缺少必要資訊',
    sentToHT: '指令資料已發送到 HT',
    outputToConsole: '指令資料已輸出到 Console (非 WebView 環境)',
    sendFailed: '傳送失敗，請查看 Console',
    dishNameRequired: '餐盤名稱 *',
    dishIdError: '餐盤ID錯誤',
    promptIdError: '缺少指令 ID',
    loadSuccess: '成功載入 {count} 個 AI Prompt 分類',
    noValidCategoryData: '檔案中沒有找到有效的分類資料',
    pleaseSelectPlateAndConfirmData: '請選擇餐盤和確認指令資料',
    promptAddedToPlate: '指令已成功加入到「{plateName}」餐盤',
    addPromptToPlateFailed: '加入指令失敗：{error}',
    loadFailed: '載入失敗：{error}',
    cannotReadFile: '無法讀取檔案',
    createDishFailed: '創建餐盤失敗：{error}',
    updateDishFailed: '更新餐盤失敗：{error}',
    checkFailed: '檢查失敗：{error}',
    addPromptFailed: '添加指令失敗：{error}',
    updatePromptFailed: '更新指令失敗：{error}',
    dishPublished: '餐盤已發布共用',
    dishShareClosed: '已關閉餐盤共用',
    noShareLinkToCopy: '無分享連結可複製',
    shareLinkCopied: '分享連結已複製到剪貼簿',
    copyLinkFailed: '複製失敗，請手動複製',
    publishFailed: '發布失敗：{error}',
    closeShareFailed: '關閉共用失敗：{error}'
  },

  // 分享指令到餐盤
  shareToPlate: {
    title: '請選擇要加入的餐盤',
    selectPlate: '選擇餐盤',
    selectPlaceholder: '請選擇餐盤',
    promptContent: '指令內容',
    adding: '加入中...',
    addToPlate: '加入',
    cancel: '取消',
    success: '指令已成功加入到「{plateName}」餐盤',
    noPlateSelected: '請選擇餐盤和確認指令資料',
    noPromptData: '沒有收到分享的指令資料',
    loginRequired: '請先登入才能分享指令到餐盤',
    noPlatesAvailable: '您還沒有任何餐盤，請先建立餐盤',
    addFailed: '加入指令失敗：{error}',
    // 預覽區域標籤
    previewLabels: {
      promptPurpose: '指令用途',
      promptCategory: '指令分類',
      usage: '用法',
      sourceData: '來源資料',
      conditionalPrompt: '條件指令內容',
      expectedOutput: 'AI輸出',
      followUpActions: '後續動作',
      personalNotes: '個人筆記'
    }
  },
  
  // 通用提示文字
  tooltips: {
    edit: '編輯',
    delete: '刪除'
  },
  
  // 複製內容時的標籤
  copyLabels: {
    purpose: '指令用途',
    category: '指令分類',
    usage: '使用方式',
    conditionalPrompt: '條件式指令',
    expectedOutput: '預期輸出'
  },
  
  // 刪除確認訊息
  deleteConfirm: {
    dishWithPrompts: '餐盤「{name}」內包含 {count} 個指令。\n刪除餐盤將同時刪除內部所有指令，此操作無法復原。\n確定要繼續嗎？',
    dishWithoutPrompts: '確定要刪除餐盤「{name}」嗎？此操作無法復原。',
    prompt: '確定要刪除指令「{name}」嗎？此操作無法復原。'
  },
  
  // 成功訊息模板
  successMessages: {
    dishDeletedWithPrompts: '餐盤「{name}」及其內部 {count} 個指令已全部刪除',
    dishDeleted: '餐盤「{name}」已刪除',
    promptDeleted: '指令已刪除'
  },
  
  // 錯誤訊息
  errors: {
    onlyXlsxSupported: '僅支援 Excel (.xlsx) 格式檔案',
    fileTooLarge: '檔案大小不能超過 10MB',
    fileTooLargeWithSize: '檔案大小不能超過 10MB，目前檔案大小：{size}',
    excelParseFailed: 'Excel解析失敗：{error}',
    fileReadFailed: '檔案讀取失敗',
    cannotGetUploadPermission: '無法獲取上傳權限',
    uploadFailed: '上傳失敗：{error}',
    sasTokenExpired: 'SAS Token 已過期，請重新獲取',
    uploadPermissionInsufficient: '上傳權限不足，請重新獲取 SAS Token',
    containerNotExists: '容器不存在',
    dishNotExistsOrDeleted: '餐盤不存在或已被刪除',
    noPermissionToDelete: '沒有權限刪除此餐盤',
    deleteDishFailed: '刪除餐盤失敗：{error}',
    deletePromptFailed: '刪除指令失敗：{error}',
    generateDownloadUrlFailed: '生成下載 URL 失敗',
    tokenParseFailed: 'Token 解析失敗',
    completeAdminVerificationFirst: '請先完成管理員驗證',
    loginInfoInvalid: '登入資訊無效，請重新登入',
    unknownError: '未知錯誤',
    fileUploadFailed: '檔案上傳失敗，請重試',
    noValidLanguageData: 'Excel檔案中沒有找到有效的語言資料',
    shareCodeSearchFailed: '搜尋失敗，請檢查分享代碼是否正確，或使用者已設為不公開',
    shareCodeNotFound: '找不到此分享代碼對應的餐盤'
  }
};